// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReturnedCheckDecisionDto } from './IReturnedCheckDecisionDto';
import {
    IReturnedCheckDecisionDtoFromJSON,
    IReturnedCheckDecisionDtoFromJSONTyped,
    IReturnedCheckDecisionDtoToJSON,
    IReturnedCheckDecisionDtoToJSONTyped,
} from './IReturnedCheckDecisionDto';

/**
 * 
 * @export
 * @interface IReturnedCheckDecisionsDto
 */
export interface IReturnedCheckDecisionsDto {
    /**
     * 
     * @type {Array<IReturnedCheckDecisionDto>}
     * @memberof IReturnedCheckDecisionsDto
     */
    returned_checks: Array<IReturnedCheckDecisionDto>;
}

/**
 * Check if a given object implements the IReturnedCheckDecisionsDto interface.
 */
export function instanceOfIReturnedCheckDecisionsDto(value: object): value is IReturnedCheckDecisionsDto {
    if (!('returned_checks' in value) || value['returned_checks'] === undefined) return false;
    return true;
}

export function IReturnedCheckDecisionsDtoFromJSON(json: any): IReturnedCheckDecisionsDto {
    return IReturnedCheckDecisionsDtoFromJSONTyped(json, false);
}

export function IReturnedCheckDecisionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReturnedCheckDecisionsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'returned_checks': ((json['returned_checks'] as Array<any>).map(IReturnedCheckDecisionDtoFromJSON)),
    };
}

export function IReturnedCheckDecisionsDtoToJSON(json: any): IReturnedCheckDecisionsDto {
    return IReturnedCheckDecisionsDtoToJSONTyped(json, false);
}

export function IReturnedCheckDecisionsDtoToJSONTyped(value?: IReturnedCheckDecisionsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'returned_checks': ((value['returned_checks'] as Array<any>).map(IReturnedCheckDecisionDtoToJSON)),
    };
}

